import FsLightbox from 'fslightbox-react';
import React, { useState } from 'react';

const Gallery = () => {
    const [activeTab, setActiveTab] = useState('GalleryTab-1');
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1,
    });

    const openLightboxOnSlide = (slideIndex) => {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: slideIndex,
        });
    };

    const galleryItems = [
        { id: 1, category: 'World Tour', image: 'img/gallery-1.jpg' },
        { id: 2, category: 'World Tour', image: 'img/gallery-2.jpg' },
        { id: 3, category: 'Ocean Tour', image: 'img/gallery-3.jpg' },
        { id: 4, category: 'Ocean Tour', image: 'img/gallery-4.jpg' },
        { id: 5, category: 'Summer Tour', image: 'img/gallery-5.jpg' },
        { id: 6, category: 'Summer Tour', image: 'img/gallery-6.jpg' },
        { id: 7, category: 'Sport Tour', image: 'img/gallery-7.jpg' },
        { id: 8, category: 'Sport Tour', image: 'img/gallery-8.jpg' },
        { id: 9, category: 'Sport Tour', image: 'img/gallery-9.jpg' },
        { id: 10, category: 'Sport Tour', image: 'img/gallery-10.jpg' },
    ];


    const tabs = [
        { id: 'GalleryTab-1', name: 'All' },
        { id: 'GalleryTab-2', name: 'World Tour' },
        { id: 'GalleryTab-3', name: 'Ocean Tour' },
        { id: 'GalleryTab-4', name: 'Summer Tour' },
        { id: 'GalleryTab-5', name: 'Sport Tour' },
    ];

    const filteredItems = galleryItems.filter(
        (item) => item.category === (activeTab === 'GalleryTab-1' ? item.category : activeTab.split('-')[1])
    );

    const filteredImages = selectedCategory === 'All'
        ? galleryItems
        : galleryItems.filter(item => item.category === selectedCategory);

    return (
        <>
            <FsLightbox
                toggler={lightboxController.toggler}
                sources={filteredImages.map(item => item.image)}
                slide={lightboxController.slide}
            />
            
            <div className="container-fluid gallery py-5 my-5">
                <div className="mx-auto text-center mb-5" style={{ maxWidth: '900px' }}>
                    <h5 className="section-title px-3">Our Gallery</h5>
                    <h1 className="mb-4">Tourism & Traveling Gallery.</h1>
                    <p className="mb-0">
                        Dive into our stunning gallery showcasing the beauty of the world's top travel destinations. From breathtaking landscapes to cultural marvels, experience the essence of travel through captivating visuals.
                    </p>
                </div>

                <div className="tab-class text-center">
                    <ul className="nav nav-pills d-inline-flex justify-content-center mb-5">
                        {tabs.map((tab) => (
                            <li className="nav-item" key={tab.id}>
                                <a
                                    className={`d-flex mx-md-3 mx-1 py-2 border border-primary bg-light rounded-pill text-decoration-none ${activeTab === tab.id ? 'active' : ''}`}
                                    data-bs-toggle="pill"
                                    onClick={() => {
                                        setActiveTab(tab.id);
                                        setSelectedCategory(tab.name);
                                    }}

                                >
                                    <span className="text-dark" style={{ width: '150px' }}>{tab.name}</span>
                                </a>
                            </li>
                        ))}
                    </ul>

                    <div className="tab-content">
                        <div id={activeTab} className="tab-pane fade show p-0 active">
                            <div className="row g-2">
                                {filteredImages.map((item, index) => {
                                    {/* const colClass = index % 2 === 0 ? 'col-xl-2' : 'col-xl-3'; */}
                                    const groupIndex = index % 5;
                                    const xlClass = (groupIndex === 1 || groupIndex === 3) ? 'col-xl-3' : 'col-xl-2';
                                    return (
                                        <div className={`col-sm-6 col-md-6 col-lg-4 ${xlClass} col-6`} key={item.id}>
                                            <div className="gallery-item h-100" onClick={() => openLightboxOnSlide(index + 1)}>
                                                <img src={item.image} className="img-fluid w-100 h-100 rounded" alt="Image" />
                                                <div className="gallery-content">
                                                    <div className="gallery-info">
                                                        <h5 className="text-white text-uppercase mb-2">{item.category}</h5>
                                                        <a className="btn-hover text-white">
                                                            View All Place <i className="fa fa-arrow-right ms-2"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="gallery-plus-icon">
                                                    <a data-lightbox={`gallery-${item.id}`} className="my-auto">
                                                        <i className="fas fa-plus fa-2x text-white"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};

export default Gallery;
